module.exports = __webpack_public_path__ + "static/jus10barbour-0090df926ca37011c909e714c5a13fec.jpg";